import { ConfigProvider as AntdConfigProvider } from 'antd';
import viVN from 'antd/locale/vi_VN';
import { ReactNode } from 'react';

interface ConfigProviderProps {
  children: ReactNode;
}

const ConfigProvider: React.FC<ConfigProviderProps> = ({ children }) => {
  return (
    <AntdConfigProvider
      locale={viVN}
      theme={{
        token: {
          colorBorder: '#D1D5DB',
          colorTextPlaceholder: '#ADAEBC',
        },
        components: {
          Table: {
            headerBg: '#E5E7EB',
            headerColor: '#6B7280',
            headerBorderRadius: 4,
          },
          Menu: {
            itemHeight: 36,
            itemPaddingInline: 12,
          },
        },
      }}
    >
      {children}
    </AntdConfigProvider>
  );
};

export default ConfigProvider;
